import { rtkApi } from '../../rtkApi';

export type BuyerDocumentCategory =
  | 'income'
  | 'assets'
  | 'liabilities'
  | 'id'
  | 'credit'
  | 'explanations';

export type BuyerDocumentRequestStatus =
  | 'requested'
  | 'uploaded'
  | 'approved'
  | 'rejected';

export interface BuyerDocumentRequest {
  _id: string;
  buyerUserId: string;
  category: BuyerDocumentCategory;
  title: string;
  status: BuyerDocumentRequestStatus;
  dueDate?: string | null;
  notes?: string;
  uploadedDocumentId?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateBuyerDocumentRequest {
  buyerUserId: string;
  category: BuyerDocumentCategory;
  title: string;
  dueDate?: string;
  notes?: string;
}

export interface UpdateBuyerDocumentRequest {
  requestId: string;
  update: Partial<{
    status: BuyerDocumentRequestStatus;
    title: string;
    dueDate: string | null;
    notes: string;
    uploadedDocumentId: string | null;
  }>;
}

export const buyerDocumentRequestsApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getBuyerDocumentRequests: builder.query<BuyerDocumentRequest[], string>({
      query: (buyerUserId) => ({
        url: `/admin/documents/users/${buyerUserId}/requests`,
        method: 'GET',
      }),
      transformResponse: (response: {
        success: boolean;
        data: BuyerDocumentRequest[];
      }) => response.data,
      providesTags: ['BuyerDocumentRequests'],
    }),
    createBuyerDocumentRequest: builder.mutation<
      BuyerDocumentRequest,
      CreateBuyerDocumentRequest
    >({
      query: ({ buyerUserId, ...data }) => ({
        url: `/admin/documents/users/${buyerUserId}/requests`,
        method: 'POST',
        data,
      }),
      transformResponse: (response: {
        success: boolean;
        data: BuyerDocumentRequest;
      }) => response.data,
      invalidatesTags: ['BuyerDocumentRequests'],
    }),
    updateBuyerDocumentRequest: builder.mutation<
      BuyerDocumentRequest,
      UpdateBuyerDocumentRequest
    >({
      query: ({ requestId, update }) => ({
        url: `/admin/documents/users/requests/${requestId}`,
        method: 'PUT',
        data: update,
      }),
      transformResponse: (response: {
        success: boolean;
        data: BuyerDocumentRequest;
      }) => response.data,
      invalidatesTags: ['BuyerDocumentRequests'],
    }),
    deleteBuyerDocumentRequest: builder.mutation<{ success: boolean }, string>({
      query: (requestId) => ({
        url: `/admin/documents/users/requests/${requestId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['BuyerDocumentRequests'],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetBuyerDocumentRequestsQuery,
  useCreateBuyerDocumentRequestMutation,
  useUpdateBuyerDocumentRequestMutation,
  useDeleteBuyerDocumentRequestMutation,
} = buyerDocumentRequestsApi;
